/* eslint functional/prefer-readonly-type: "error" */
import React from "react";
import { GroupProps } from "./GroupProps";
import CategoryFilterGroup from "./CategoryFilterGroup";
const CategoryFilter = ({
  groups,
  toggleCollapsed,
  prefetch
}: GroupProps) => {
  if (!groups.length) return <></>;
  const isFilterSelected = groups.some(group => group.groupItems.some(groupItem => groupItem.isSelected));
  const categoryGroups = isFilterSelected ? groups.filter(group => group.groupItems.some(groupItem => groupItem.isSelected)) : groups;
  const selectedCategoryFilterHeading = <span>Selected category filter:</span>;
  const noSelectedCategoryFilterHeading = <span className="w-32">Select a category to view more filters</span>;
  return <>
      <li className="mx-1 lt:mx-0" data-test="CategoryFilter" key="categoryFilter-header">
        <p className="filter-list__section selectCategory w-full text-start align-middle border-0 lt:bg-transparent focus:outline-offset-[-3px] mb-1">
          {isFilterSelected ? selectedCategoryFilterHeading : noSelectedCategoryFilterHeading}
        </p>
      </li>
      <li key="categoryFilter-body" className="filter-list__section category-nav border-b-0 mr-1 lt:mr-0" id="categoryFilter">
        {categoryGroups.map(group => <CategoryFilterGroup group={group} toggleCollapsed={toggleCollapsed} key={group.groupName} prefetch={prefetch} />)}
      </li>
    </>;
};
export default CategoryFilter;